
import React, { Component } from 'react';

import TextField from '@material-ui/core/TextField';
import { YellowButton } from 'ui/Button';
import styled from 'styled-components';
import { UserContext } from '.';
import Paper from '@material-ui/core/Paper';

const LoginContainer = styled.div`
  display: grid;
	height: 100dvh;
	background: #FBFBFB;
`;

const Container = styled.div`
  width: min(350px, calc(100vw - 24px));
  align-self: center;
  justify-self: center;
`;

const StyledPaper = styled(Paper)`
  padding: 40px;
  
  h2 {
    font-size: 1.4em;
    margin: 0;
    padding: 0;
  }
`;


export default class LoginForm extends Component {

  static defaultProps = {
    formTitle: 'Вход',
    LogoComponent: undefined
  }

  constructor(props) {
    super(props);

    this.state = {
      username: '',
      password: '',
      loading: false,
      showPassword: false
    };

    this.usernameInput = React.createRef();
    this.passwordInput = React.createRef();
  }

  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  handleSubmit = async (event, callback) => {
    event.preventDefault();

    if (this.state.username.length === 0) {
      this.usernameInput.current.focus();
      return;
    }

    if (this.state.password.length === 0) {
      this.passwordInput.current.focus();
      return;
    }

    this.setState({loading: true});
    const isLoggedIn = await callback(this.state.username, this.state.password);
    if (isLoggedIn === false) {
      this.setState({loading: false});
      this.usernameInput.current.focus();
    }
  };

  componentDidMount() {
    this.usernameInput.current.focus();
  }

  render() {
    const { loading } = this.state;
    const { formTitle, logo } = this.props;

    return(
      <LoginContainer>
        <UserContext.Consumer>
          {value => {
            const { logIn } = value.actions;
            return (
              <Container>
                {logo && (
                  <div className={'text-center mb-40'}>
                    {logo}
                  </div>
                )}
                <StyledPaper>
                  <div className={'text-center mb-20'}><h2>{formTitle}</h2></div>
                  <form onSubmit={(e) => this.handleSubmit(e, logIn)}>
                    <TextField
                      value={this.state.username}
                      name="username"
                      onChange={(e) => this.handleChange(e)}
                      inputRef={this.usernameInput}
                      label={'Логин'}
                      variant={'outlined'}
                      fullWidth={true}
                      className={'mb-20'}
                    />

                    <TextField
                      value={this.state.password}
                      name="password"
                      type="password"
                      onChange={(e) => this.handleChange(e)}
                      label={'Пароль'}
                      variant={'outlined'}
                      inputRef={this.passwordInput}
                      fullWidth={true}
                      className={'mb-20'}
                    />

                    <YellowButton
                      type="submit"
                      size={'large'}
                      fullWidth={true}
                      disabled={loading}
                    >
                      Войти
                    </YellowButton>
                  </form>
                </StyledPaper>
              </Container>
            )
          }}
        </UserContext.Consumer>
      </LoginContainer>
    )
  }
}
